module.exports = __webpack_public_path__ + "img/progress_006.7ecfb941.png";